import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "./authConfig";

/**
 * Is this role in the roles array?
 */
export const hasRole = ( roles: string[] | undefined, role: string) => {
    if (roles === undefined || roles.length === 0) return false;

    return roles.includes(role);
}

/**
 * Get token for every call.
 */
export async function addAuthenticationHeader(headers: Headers) 
{
	const msalInstance = new PublicClientApplication(msalConfig);
	
	try
	{
		msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
		const authenticationResult = await msalInstance.acquireTokenSilent(loginRequest);
		headers.set('Authorization', authenticationResult.accessToken);
	}
	catch // Any error above will end up here
	{
		msalInstance.loginRedirect();
	}

	return headers;
}